var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "damageMobilier-category3 view" },
    [
      !_vm.isE2EFlow
        ? _c("div", { staticClass: "navbarCategories" }, [
            _c("img", {
              staticClass: "check-img",
              attrs: {
                src: require("@/assets/images/self-care/arrow-left.png"),
              },
              on: { click: _vm.goToDamageMobilier },
            }),
            _c("p", { staticClass: "grayLightMouse headline-medium" }, [
              _vm._v(_vm._s(_vm.stateWarrantyDamagedPartKey)),
            ]),
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "view_top" },
        [
          _c("maNotificationsTop", {
            attrs: { errorMsgGeneral: _vm.errorMsg, errorIsVisible: _vm.error },
          }),
        ],
        1
      ),
      _vm.isE2EFlow
        ? _c(
            "div",
            { staticClass: "view_top" },
            [
              _c("ma-navbar-stepper", {
                attrs: {
                  numberOfStep: 2,
                  textOfStep: _vm.$t("Déclaration des dommages"),
                  arrowIsAllow: true,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.flowName === "damage_billma_agent_new" || _vm.flowName === "e2e_new"
        ? _c(
            "maDamagesCamera",
            {
              ref: "damagesCamera",
              staticClass: "save-button",
              on: { photosAdded: _vm.handleCameraPhotos },
            },
            [
              _c("ma-navbar-category-specific", {
                attrs: {
                  titleNavbar: _vm.titleCategory,
                  handleClickBackArrow: _vm.handleClickPrevPage,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c("div", { staticClass: "view_content" }, [
        _vm.formType === "formInputsMobilier"
          ? _c("div", { staticClass: "container-form" }, [
              _c("div", { staticClass: "view_content_markdown" }, [
                _c("h1", [_vm._v(_vm._s(_vm.titleCategory))]),
                _c("p", [
                  _vm._v(_vm._s(_vm.stateWarrantyLiteralsMobilier.cat2)),
                ]),
                _c("p", [
                  _vm._v(_vm._s(_vm.stateWarrantyLiteralsMobilier.cat1)),
                ]),
              ]),
              _vm.flowName !== "damage_billma_agent_new" &&
              _vm.flowName !== "e2e_new"
                ? _c(
                    "ul",
                    { staticClass: "listForms" },
                    [
                      _c("ma-form", {
                        key: _vm.formKey,
                        staticClass: "mg-mg-t",
                        attrs: {
                          type: "large",
                          formData: _vm.formData.form,
                          titleFileInputPres: _vm.$t(
                            "damageDetails.titleFileInputPres"
                          ),
                          nameFileInputPres: "inputImgPres",
                          inputImgListPres: _vm.imgListPres,
                          showInputFile: true,
                        },
                        on: {
                          change: function ($event) {
                            _vm.handleFormChange($event)
                            _vm.handleNestedComponents($event)
                          },
                          "file:change-pres": _vm.handleImgChangePres,
                        },
                        nativeOn: {
                          focus: function ($event) {
                            return _vm.handleInputFocus()
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.flowName === "damage_billma_agent_new" ||
              _vm.flowName === "e2e_new"
                ? _c(
                    "ul",
                    { staticClass: "listForms" },
                    [
                      _c("ma-form", {
                        key: _vm.formKey,
                        staticClass: "mg-mg-t",
                        attrs: {
                          type: "large",
                          formData: _vm.formData.form,
                          showInputFile: false,
                        },
                        on: {
                          change: function ($event) {
                            _vm.handleFormChange($event)
                            _vm.handleNestedComponents($event)
                          },
                        },
                        nativeOn: {
                          focus: function ($event) {
                            return _vm.handleInputFocus()
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.flowName === "damage_billma_agent_new" ||
              _vm.flowName === "e2e_new"
                ? _c(
                    "div",
                    { staticClass: "container-btn-add-element-camera" },
                    [
                      _vm.imgListNewCamera.length === 0 && !_vm.noRequiredPhotos
                        ? _c(
                            "button",
                            {
                              staticClass: "btn",
                              on: { click: _vm.handleOnShowModalCamera },
                            },
                            [
                              _c("svgicon", {
                                attrs: {
                                  name: "camera-create",
                                  color: "#005BA5",
                                  height: "15",
                                  width: "auto",
                                },
                              }),
                              _c("p", { staticClass: "text-medium" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "multidamageList.cameraFlow.cameraBtn2"
                                    )
                                  )
                                ),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.noRequiredPhotos
                        ? _c(
                            "button",
                            {
                              staticClass: "btn buttonLink",
                              on: { click: _vm.handleNoPhotosRequired },
                            },
                            [
                              _c("p", { staticClass: "text-medium black" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "multidamageList.cameraFlow.noRequired"
                                    )
                                  )
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
              _vm.flowName === "damage_billma_agent_new" &&
              _vm.imgListNewCamera.length > 0
                ? _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.noRequiredPhotos,
                          expression: "!noRequiredPhotos",
                        },
                      ],
                      staticClass: "list-damage-images",
                    },
                    [
                      _c("div", { staticClass: "p text-medium" }, [
                        _vm._v(
                          _vm._s(_vm.$t("damageDetails.titleFileInputPres"))
                        ),
                        _c("div", { staticClass: "camera__damages" }, [
                          _c(
                            "div",
                            { staticClass: "damage__photos" },
                            _vm._l(_vm.imgListNewCamera, function (image) {
                              return _c(
                                "figure",
                                { staticClass: "damage-img" },
                                [_c("img", { attrs: { src: image.imageURL } })]
                              )
                            }),
                            0
                          ),
                        ]),
                      ]),
                    ]
                  )
                : _vm._e(),
            ])
          : _vm.formType === "uptecFeature"
          ? _c(
              "div",
              { staticClass: "container-form_feature" },
              [
                _c("div", { staticClass: "containerImgProduct mg mg--t-8" }, [
                  _c("img", {
                    attrs: { src: _vm.stateWarrantyObjUptec.imageFeature },
                  }),
                ]),
                _c(
                  "p",
                  { staticClass: "gray headline-large mg mg--t-8 mg--b-1" },
                  [_vm._v(_vm._s(_vm.titleCategory))]
                ),
                _c("p", { staticClass: "gray text-medium-large mg mg--b-1" }, [
                  _vm._v(_vm._s(_vm.stateWarrantyLiteralsMobilier.cat2)),
                ]),
                _c("p", { staticClass: "gray text-medium-large mg mg--b-5" }, [
                  _vm._v(_vm._s(_vm.stateWarrantyLiteralsMobilier.cat1)),
                ]),
                _c("ma-date-picker", {
                  attrs: {
                    errorInput: _vm.errorDate,
                    handleChangeInput: _vm.handleChangeInputDate,
                    literal: _vm.$t("datePicker.literal"),
                  },
                }),
                _vm.flowName === "damage_billma_agent_new" ||
                _vm.flowName === "e2e_new"
                  ? _c(
                      "div",
                      { staticClass: "container-btn-add-element-camera" },
                      [
                        _vm.imgListNewCamera.length === 0 &&
                        !_vm.noRequiredPhotos
                          ? _c(
                              "button",
                              {
                                staticClass: "btn",
                                on: { click: _vm.handleOnShowModalCamera },
                              },
                              [
                                _c("svgicon", {
                                  attrs: {
                                    name: "camera-create",
                                    color: "#005BA5",
                                    height: "15",
                                    width: "auto",
                                  },
                                }),
                                _c("p", { staticClass: "text-medium" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "multidamageList.cameraFlow.cameraBtn2"
                                      )
                                    )
                                  ),
                                ]),
                              ],
                              1
                            )
                          : _vm._e(),
                        !_vm.noRequiredPhotos
                          ? _c(
                              "button",
                              {
                                staticClass: "btn buttonLink",
                                on: { click: _vm.handleNoPhotosRequired },
                              },
                              [
                                _c("p", { staticClass: "text-medium black" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "multidamageList.cameraFlow.noRequired"
                                      )
                                    )
                                  ),
                                ]),
                              ]
                            )
                          : _vm._e(),
                      ]
                    )
                  : _vm._e(),
                _vm.flowName === "damage_billma_agent_new" ||
                (_vm.flowName === "e2e_new" && _vm.imgListNewCamera.length > 0)
                  ? _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.noRequiredPhotos,
                            expression: "!noRequiredPhotos",
                          },
                        ],
                        staticClass: "list-damage-images mg mg--t-4",
                      },
                      [
                        _c("div", { staticClass: "p text-medium" }, [
                          _vm._v(
                            _vm._s(_vm.$t("damageDetails.titleFileInputPres"))
                          ),
                          _c("div", { staticClass: "camera__damages" }, [
                            _c(
                              "div",
                              { staticClass: "damage__photos" },
                              _vm._l(_vm.imgListNewCamera, function (image) {
                                return _c(
                                  "figure",
                                  { staticClass: "damage-img" },
                                  [
                                    _c("img", {
                                      attrs: { src: image.imageURL },
                                    }),
                                  ]
                                )
                              }),
                              0
                            ),
                          ]),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm.flowName !== "damage_billma_agent_new" &&
                _vm.flowName !== "e2e_new"
                  ? _c("ma-input-file", {
                      staticClass: "mg mg--b-22",
                      attrs: {
                        titleInput: _vm.$t("damageDetails.titleFileInputPres"),
                        name: "inputImgPres",
                        imageList: _vm.imgListPres,
                      },
                      on: { "file:src": _vm.handleImgChangePres },
                    })
                  : _vm._e(),
                _c(
                  "ma-modal",
                  {
                    ref: "modalConfirmationFeature",
                    staticClass: "modal-confirmation",
                    attrs: { type: "small" },
                    on: { "modal:close": _vm.closeModaConfirmationFeature },
                  },
                  [
                    _c("template", { slot: "modalContent" }, [
                      _c(
                        "div",
                        { staticClass: "modal__main" },
                        [
                          _c(
                            "p",
                            { staticClass: "gray headline-large mg mg--b-3" },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("damageMobilier.category.modal1"))
                              ),
                            ]
                          ),
                          _c(
                            "p",
                            {
                              staticClass: "gray text-medium-large mg mg--b-10",
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("damageMobilier.category.modal2"))
                              ),
                            ]
                          ),
                          _c(
                            "p",
                            { staticClass: "text-small-bold black mg mg--b-1" },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("damageMobilier.category.date"))
                              ),
                            ]
                          ),
                          _c(
                            "p",
                            {
                              staticClass: "text-small-bold black mg mg--b-10",
                            },
                            [_vm._v(_vm._s(_vm.showDateWithCorrectForm))]
                          ),
                          _c("ma-add-damages", {
                            staticClass: "buttonsNextActions",
                            attrs: {
                              handleButtonClick:
                                _vm.handleAddDamagesFeatureUptec,
                              handleButtonClickWhiteBtn:
                                _vm.closeModaConfirmationFeature,
                              title: _vm.$t(
                                "damageMobilier.category.buttonsNextActionsTitle"
                              ),
                              titleWhiteBtn: _vm.$t(
                                "damageMobilier.category.buttonsNextActionsTitleWhiteBtn"
                              ),
                              btnType: "functionalBtnWhite",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                ),
              ],
              1
            )
          : _vm.formType === "uptecCpi"
          ? _c(
              "div",
              { staticClass: "container-form_cpi" },
              [
                _c(
                  "p",
                  { staticClass: "gray headline-large mg mg--t-4 mg--b-1" },
                  [_vm._v(_vm._s(_vm.titleCategory))]
                ),
                _c("p", { staticClass: "gray text-medium-large mg mg--b-1" }, [
                  _vm._v(_vm._s(_vm.stateWarrantyLiteralsMobilier.cat2)),
                ]),
                _c("p", { staticClass: "gray text-medium-large mg mg--b-3" }, [
                  _vm._v(_vm._s(_vm.stateWarrantyLiteralsMobilier.cat1)),
                ]),
                _c("ma-date-picker", {
                  attrs: {
                    errorInput: _vm.errorDate,
                    handleChangeInput: _vm.handleChangeInputDate,
                    literal: _vm.$t("datePicker.literal"),
                  },
                }),
                _c("ma-input-txt", {
                  staticClass: "mg mg--b-5",
                  attrs: {
                    type: "text",
                    required: "",
                    name: "inputPrice",
                    col: "4",
                    icon: "",
                    literal: _vm.$t("damageMobilier.category.price"),
                    inputError: _vm.errorPrice,
                    inputTextError: _vm.$t(
                      "damageMobilier.category.inputTextError"
                    ),
                  },
                  model: {
                    value: _vm.inputValPrice,
                    callback: function ($$v) {
                      _vm.inputValPrice = $$v
                    },
                    expression: "inputValPrice",
                  },
                }),
                _vm.flowName === "damage_billma_agent_new" ||
                _vm.flowName === "e2e_new"
                  ? _c(
                      "div",
                      { staticClass: "container-btn-add-element-camera" },
                      [
                        _vm.imgListNewCamera.length === 0 &&
                        !_vm.noRequiredPhotos
                          ? _c(
                              "button",
                              {
                                staticClass: "btn",
                                on: { click: _vm.handleOnShowModalCamera },
                              },
                              [
                                _c("svgicon", {
                                  attrs: {
                                    name: "camera-create",
                                    color: "#005BA5",
                                    height: "15",
                                    width: "auto",
                                  },
                                }),
                                _c("p", { staticClass: "text-medium" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "multidamageList.cameraFlow.cameraBtn2"
                                      )
                                    )
                                  ),
                                ]),
                              ],
                              1
                            )
                          : _vm._e(),
                        !_vm.noRequiredPhotos
                          ? _c(
                              "button",
                              {
                                staticClass: "btn buttonLink",
                                on: { click: _vm.handleNoPhotosRequired },
                              },
                              [
                                _c("p", { staticClass: "text-medium black" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "multidamageList.cameraFlow.noRequired"
                                      )
                                    )
                                  ),
                                ]),
                              ]
                            )
                          : _vm._e(),
                      ]
                    )
                  : _vm._e(),
                _vm.flowName === "damage_billma_agent_new" ||
                (_vm.flowName === "e2e_new" && _vm.imgListNewCamera.length > 0)
                  ? _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.noRequiredPhotos,
                            expression: "!noRequiredPhotos",
                          },
                        ],
                        staticClass: "list-damage-images",
                      },
                      [
                        _c("div", { staticClass: "p text-medium" }, [
                          _vm._v(
                            _vm._s(_vm.$t("damageDetails.titleFileInputPres"))
                          ),
                          _c("div", { staticClass: "camera__damages" }, [
                            _c(
                              "div",
                              { staticClass: "damage__photos" },
                              _vm._l(_vm.imgListNewCamera, function (image) {
                                return _c(
                                  "figure",
                                  { staticClass: "damage-img" },
                                  [
                                    _c("img", {
                                      attrs: { src: image.imageURL },
                                    }),
                                  ]
                                )
                              }),
                              0
                            ),
                          ]),
                        ]),
                      ]
                    )
                  : _vm._e(),
                _vm.flowName !== "damage_billma_agent_new" &&
                _vm.flowName !== "e2e_new"
                  ? _c("ma-input-file", {
                      attrs: {
                        titleInput: _vm.$t(
                          "damageDetails.titleFileInputEnsemble"
                        ),
                        name: "inputImgEnsemble",
                        imageList: _vm.imgListEnsemble,
                      },
                      on: { "file:src": _vm.handleImgChangeEnsemble },
                    })
                  : _vm._e(),
                _c(
                  "ma-modal",
                  {
                    ref: "modalConfirmation",
                    staticClass: "modal-confirmation",
                    attrs: { type: "small" },
                    on: { "modal:close": _vm.closeModaConfirmation },
                  },
                  [
                    _c("template", { slot: "modalContent" }, [
                      _c(
                        "div",
                        { staticClass: "modal__main" },
                        [
                          _c(
                            "p",
                            { staticClass: "gray headline-large mg mg--b-3" },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("damageMobilier.category.modal1"))
                              ),
                            ]
                          ),
                          _c(
                            "p",
                            {
                              staticClass: "gray text-medium-large mg mg--b-5",
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("damageMobilier.category.modal2"))
                              ),
                            ]
                          ),
                          _c(
                            "p",
                            { staticClass: "text-small-bold black mg mg--b-1" },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("damageMobilier.category.date"))
                              ),
                            ]
                          ),
                          _c(
                            "p",
                            { staticClass: "text-small-bold black mg mg--b-5" },
                            [_vm._v(_vm._s(_vm.showDateWithCorrectForm))]
                          ),
                          _c(
                            "p",
                            { staticClass: "text-small-bold black mg mg--b-1" },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("damageMobilier.category.price"))
                              ),
                            ]
                          ),
                          _c(
                            "p",
                            { staticClass: "text-small-bold black mg mg--b-5" },
                            [_vm._v(_vm._s(_vm.inputValPrice))]
                          ),
                          _c("ma-add-damages", {
                            staticClass: "buttonsNextActions",
                            attrs: {
                              handleButtonClick: _vm.handleAddDamagesCpi,
                              handleButtonClickWhiteBtn:
                                _vm.closeModaConfirmation,
                              title: _vm.$t(
                                "damageMobilier.category.buttonsNextActionsTitle"
                              ),
                              titleWhiteBtn: _vm.$t(
                                "damageMobilier.category.buttonsNextActionsTitleWhiteBtn"
                              ),
                              btnType: "functionalBtnWhite",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      _c(
        "div",
        { staticClass: "view_actions" },
        [
          _vm.formType === "formInputsMobilier"
            ? _c("ma-add-damages", {
                attrs: {
                  handleButtonClick: _vm.handleAddDamages,
                  title: _vm.$t("addDamages.buttonTitle"),
                  btnType: _vm.getBtnType,
                  shouldBeDisabled: _vm.isDisabledBtn,
                  "qa-confirmSinisterInfo-button": "",
                },
              })
            : _vm.formType === "uptecFeature"
            ? _c("ma-add-damages", {
                attrs: {
                  handleButtonClick: _vm.handleOpenModalFeature,
                  title: _vm.$t("addDamages.buttonTitleFeature"),
                  shouldBeDisabled: !_vm.inputValDate,
                  btnType: _vm.getBtnType,
                },
              })
            : _vm.formType === "uptecFeature" &&
              _vm.flowName !== "damage_billma_agent_new" &&
              _vm.flowName !== "e2e_new"
            ? _c("ma-add-damages", {
                attrs: {
                  handleButtonClick: _vm.handleOpenModalFeature,
                  title: _vm.$t("addDamages.buttonTitleFeature"),
                  shouldBeDisabled: !_vm.inputValDate || !_vm.noRequiredPhotos,
                  btnType: _vm.getBtnType,
                },
              })
            : _vm.formType === "uptecCpi"
            ? _c("ma-add-damages", {
                attrs: {
                  handleButtonClick: _vm.handleOpenModal,
                  title: _vm.$t("addDamages.buttonTitle"),
                  shouldBeDisabled: !_vm.inputValPrice || !_vm.inputValDate,
                  btnType: _vm.getBtnType,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }